import {useEffect, useState} from "react";
import {useLoaderState} from "../../../../lib/api/loaderState";
import {useOrdersApi} from "../../../../lib/api/useOrdersApi";
import {TSubscriptionOptions, useTypedPublicEndpoints} from "../../../../lib/api/useTypedPublicEndpoint";
import {useInjection} from "brandi-react";
import {PayBlockModelStoreToken} from "../../../common/PayBlock/models/PayBlockModel/index.model";
import {PaymentPayMethodsObject} from "../../../common/PayBlock/constants";

//@ts-ignore
const useOrder = ({orderId, setOrder, setSelectedSlot, setPeopleAmount, setIsSubscriptionPay}) => {
    const {setIsLoading} = useLoaderState();
    const {getOrder} = useOrdersApi();
    const {calculateSubscription} = useTypedPublicEndpoints();

    const [subscriptionData, setSubscriptionData] = useState<TSubscriptionOptions>();

    const payBlockModel = useInjection(PayBlockModelStoreToken);

    const paymentMethod = payBlockModel.getCurrentMethod;

    async function fetchOrder(orderId: number | string) {

        const order = await getOrder(orderId);
        setOrder(() => order);
        setSelectedSlot(order.slot)
        setPeopleAmount(order.paidForLength);
        setIsSubscriptionPay(() => !!order.subscriptionAppliedId)
    }

    useEffect(() => {
        setIsLoading(true)
        if (orderId) {
            fetchOrder(orderId).catch(err => console.log(err));
        } else {
            setSubscriptionData(undefined)
        }
        setIsLoading(false);
    }, [orderId]);

    useEffect(() => {
        if (orderId) paymentMethod === PaymentPayMethodsObject.SUB && calculateSubscription(orderId).then(setSubscriptionData);
    }, [paymentMethod, orderId]);

    return {subscriptionData}
}

export default useOrder;